<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" id="table-of-contents">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-upper">CONTENTS</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/acknowledgments"><span class="item-title-text">Acknowledgments</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">1. </span><a href="#/chapter001"><span class="item-title-text">Seattle’s Hidden Secret</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">2. </span><span href="#/chapter002" title="Link target outside of Sample"><span class="item-title-text">All Bet’s Aside</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">3. </span><span href="#/chapter003" title="Link target outside of Sample"><span class="item-title-text">You Can Do It</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">4. </span><span href="#/chapter004" title="Link target outside of Sample"><span class="item-title-text">Creating a Strong Foundation</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">5. </span><span href="#/chapter005" title="Link target outside of Sample"><span class="item-title-text">Flight or Fight:</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">6. </span><span href="#/chapter006" title="Link target outside of Sample"><span class="item-title-text">I Got You</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">7. </span><span href="#/chapter007" title="Link target outside of Sample"><span class="item-title-text">My Comfort Zone</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">8. </span><span href="#/chapter008" title="Link target outside of Sample"><span class="item-title-text">A Taste of Seattle</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">9. </span><span href="#/chapter009" title="Link target outside of Sample"><span class="item-title-text">An Elegant Affair</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">10. </span><span href="#/chapter010" title="Link target outside of Sample"><span class="item-title-text">The Meeting</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">11. </span><span href="#/chapter011" title="Link target outside of Sample"><span class="item-title-text">Spacation</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">12. </span><span href="#/chapter012" title="Link target outside of Sample"><span class="item-title-text">It’s Complicated</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">13. </span><span href="#/chapter013" title="Link target outside of Sample"><span class="item-title-text">We Are More Alike Than Different</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">14. </span><span href="#/chapter014" title="Link target outside of Sample"><span class="item-title-text">Battle Scars</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">15. </span><span href="#/chapter015" title="Link target outside of Sample"><span class="item-title-text">I Would Never Run</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">16. </span><span href="#/chapter016" title="Link target outside of Sample"><span class="item-title-text">Let’s Go to Alaska</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">17. </span><span href="#/chapter017" title="Link target outside of Sample"><span class="item-title-text">Get a Room</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">18. </span><span href="#/chapter018" title="Link target outside of Sample"><span class="item-title-text">Kate the Great</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">19. </span><span href="#/chapter019" title="Link target outside of Sample"><span class="item-title-text">We Were Destined to Meet</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">20. </span><span href="#/chapter020" title="Link target outside of Sample"><span class="item-title-text">Undercover Boss</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">21. </span><span href="#/chapter021" title="Link target outside of Sample"><span class="item-title-text">A Day of Reckoning</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">22. </span><span href="#/chapter022" title="Link target outside of Sample"><span class="item-title-text">Where is Our Next Adventure?</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/thedaysofpleasureseries" title="Link target outside of Sample"><span class="item-title-text">The Days of Pleasure Series</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="item-title-text">About the Author</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/untitled1amazonbestseller" title="Link target outside of Sample"><span class="item-title-text">#1 Amazon Best Seller</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/amazonreviews" title="Link target outside of Sample"><span class="item-title-text">Amazon Reviews</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?b0340206